import { useMemo } from 'react';

import { DeviceType, EPopupSubType, IframePreview } from '@appcharge/shared-ui';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { cn } from 'components/lib/utils';

export const StorePreview: React.FC<{
  previewProps: React.ComponentProps<typeof IframePreview>;
}> = ({ previewProps }) => {
  const { previewScreenResolution } = useTemplateStudioState();

  const isMobile = useMemo(
    () => previewProps.device === DeviceType.MOBILE,
    [previewProps]
  );

  const desktopWidthPct = previewScreenResolution ?? 100;

  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-lg relative',
        isMobile
          ? 'mobile-preview w-[420px] h-[90%]'
          : 'desktop-preview h-[100%]'
      )}
      style={
        isMobile
          ? undefined
          : {
              width: `${desktopWidthPct}%`,
              transition: 'width 150ms ease'
            }
      }
      id="store-preview-wrapper"
    >
      <IframePreview
        {...previewProps}
        width={isMobile ? 420 : undefined}
        height="100%"
      />
      {previewProps.displayPopup &&
        previewProps.displayPopupSubType === EPopupSubType.REWARD_CALENDAR && (
          <div className="absolute inset-0 z-10 pointer-events-auto" />
        )}
    </div>
  );
};
